// Client for the account deletion endpoints of the lawyer backend
// (partners_app/services/account_deletion.py).

import { request } from './client';

export { ApiError } from './client';

export type DeletionStatus = 'requested' | 'closed' | 'purged';

export interface DeletionCase {
  id: string;
  service: string | null;
  status: string | null;
  lawyer_status: string | null;
  applicant_type: string | null;
  name: string | null;
  paid: boolean;
}

export interface DeletionRequest {
  uid: string;
  email: string | null;
  name: string | null;
  locale: string | null;
  tenantId: string | null;
  status: DeletionStatus;
  requestedAt: string | null;
  dueAt: string | null;
  closedAt: string | null;
  closedBy: string | null;
  purgedAt: string | null;
  purgedBy: string | null;
  deleted: Record<string, number> | null;
  cases: DeletionCase[];
  blockers: string[];
  not_covered?: string[];
}

export const listDeletionRequests = async (token: string): Promise<DeletionRequest[]> => {
  const data = await request(token, '/deletion-requests', { method: 'GET' }, 'Failed to load deletion requests.');
  return data?.requests || [];
};

export const closeAccount = (token: string, uid: string): Promise<DeletionRequest> =>
  request(token, `/deletion-requests/${encodeURIComponent(uid)}/close`, { method: 'POST' }, 'Failed to close the account.');

export const purgeAccount = (token: string, uid: string): Promise<DeletionRequest> =>
  request(token, `/deletion-requests/${encodeURIComponent(uid)}/purge`, { method: 'POST' }, 'Failed to delete the data.');
